namespace Matrix.Data {

	@Serenity.Decorators.registerClass()
	export class SecurityPickerDialog extends Serenity.TemplatedDialog<any> {

		private pickerGrid: SecurityPickerGrid;

		constructor() {
			super();

			this.pickerGrid = new SecurityPickerGrid(this.byId("PickerGrid"));
			this.dialogTitle = "Select Securities";
		}

        public allowClear: boolean;

		protected getTemplate() {
			return `<div id="~_PickerGrid"></div>`;
		}

		protected getDialogOptions() {
			var opt = super.getDialogOptions();
			opt.buttons = [
				{
					text: Q.text("Dialogs.OkButton"),
					click: () => {
						var selected = this.pickerGrid.selectedItems;
						if (!this.allowClear && !selected.length) {
							Q.notifyWarning("Please select securities");
							return;
						}

						if (!this.onSuccess || this.onSuccess(selected))
							this.dialogClose();
					}
				},
				{
					text: Q.text("Dialogs.CancelButton"),
					click: () => {
						this.dialogClose();
					}
				}
			];
			return opt;
		}

		get selectedItems() {
			return this.pickerGrid.selectedItems;
		}

		get value() {
			return this.pickerGrid.value;
		}

		set value(value: string[]) {
			this.pickerGrid.value = value;
		}

        set criteria(value: any[]) {
            this.pickerGrid.criteria = value;
        }

		public onSuccess: (selected: SecurityRow[]) => boolean;
	}
}